import { useCopiedState } from "../../../../core/util/hooks";
import { setFilter, removeFilter, initialState } from "../disputeUXSlice";
import { invalidateDispute } from "../disputeDataSlice";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import React from "react";
import { DisputeFilter } from "../types";

export const useDisputeFilter = () => {
  const [storeFilter] = useCurrentDisputeFilter();

  const [filter, editFilter, changeState, setCurrentFilter] = useCopiedState< DisputeFilter>(storeFilter);

  const dispatch = useDispatch();
  const dispatchSetFilter = React.useCallback(() => {
    dispatch(setFilter(filter!));
    dispatch(invalidateDispute());
  }, [dispatch, filter]);

  const dispatchResetFilter = React.useCallback(() => {
    setCurrentFilter(initialState.filter);
  }, [setCurrentFilter]);


  return [
    filter,
    editFilter,
    dispatchSetFilter,
    changeState,
    dispatchResetFilter,
  ] as [
    typeof filter,
    typeof editFilter,
    typeof dispatchSetFilter,
    typeof changeState,
    typeof dispatchResetFilter
  ];

};

export const useCurrentDisputeFilter = () => {
  const filter = useSelector<StoreType, DisputeFilter>(
    (store) => store.ux.clearing.disputes.filter
  );
  const dispatch = useDispatch();
  const dispatchRemoveFilter = React.useCallback(
    (type: keyof DisputeFilter) => {
      dispatch(removeFilter(type));
      dispatch(invalidateDispute());
    },
    [dispatch]
  );

  return [filter, dispatchRemoveFilter] as [
    typeof filter,
    typeof dispatchRemoveFilter
  ];
};
